import * as R from 'ramda'
import React from 'react'
import PropTypes from 'prop-types'
import { Modal, Button } from 'semantic-ui-react'
import { withStateHandlers } from 'recompose'

import GenericEmbedCard from './GenericEmbedCard'
import HelpdeskCard from './HelpdeskCard'
import { images } from 'packages/simplesat-config'

const ChooseHelpdeskModal = ({
  isOpenModal,
  handleClose,
  handleOnClick,
  onSurveyClicked,
  clearSelectedSurvey,
  selectedSurvey,
  isLoading,
}) => (
  <Modal open={isOpenModal} onClose={R.compose(clearSelectedSurvey, handleClose)}>
    <Modal.Header>
      <div className="header">Choose Your Helpdesk</div>
    </Modal.Header>
    <Modal.Content>
      <Modal.Description>
        <GenericEmbedCard
          image={images.genericEmbedBoxImg}
          onClick={R.partial(onSurveyClicked, ['generic_embed'])}
          selectedSurvey={selectedSurvey}
          label="Generic Embed"
          type="generic_embed"
          description="Add a survey to an email signature or helpdesk not listed below."
        />
        <h4>Helpdesks</h4>
        <div className="ui four stackable cards integration">
          <HelpdeskCard
            image={images.autotaskBoxImg}
            onClick={R.partial(onSurveyClicked, ['autotask'])}
            selectedSurvey={selectedSurvey}
            label="Autotask"
            type="autotask"
          />
          <HelpdeskCard
            image={images.connectwiseBoxImg}
            onClick={R.partial(onSurveyClicked, ['connectwise'])}
            selectedSurvey={selectedSurvey}
            label="ConnectWise"
            type="connectwise"
          />
          <HelpdeskCard
            image={images.zendeskBoxImg}
            onClick={R.partial(onSurveyClicked, ['zendesk'])}
            selectedSurvey={selectedSurvey}
            label="Zendesk"
            type="zendesk"
          />
        </div>
      </Modal.Description>
    </Modal.Content>
    <Modal.Actions>
      <Button onClick={R.compose(clearSelectedSurvey, handleClose)}>Cancel</Button>
      <Button
        className="primary"
        loading={isLoading}
        onClick={handleOnClick}
        disabled={!selectedSurvey}
      >
        Create Survey
      </Button>
    </Modal.Actions>
  </Modal>
)

ChooseHelpdeskModal.propTypes = {
  isOpenModal: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  handleOnClick: PropTypes.func.isRequired,
  onSurveyClicked: PropTypes.func.isRequired,
  clearSelectedSurvey: PropTypes.func.isRequired,
  selectedSurvey: PropTypes.string,
  isLoading: PropTypes.bool,
}

const enhance = withStateHandlers(
  { selectedSurvey: null },
  {
    onSurveyClicked: (state, props) => (type) => {
      props.selectSurvey(type)
      return {
        selectedSurvey: type,
      }
    },
    clearSelectedSurvey: () => () => {
      return { selectedSurvey: null }
    },
  }
)

export default enhance(ChooseHelpdeskModal)



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/Admin/Surveys/ChooseHelpdeskModal/index.js